import { ChangeDetectorRef, Component, EventEmitter, NgZone, OnInit, Output, ViewChild, ViewEncapsulation } from "@angular/core";
import { RequestsService } from "../../../../shared/services/requests.service";
import { RequestCategoryService } from "../../../../shared/services/request-categoty.service";
import { forkJoin, Subject } from "rxjs";
import { RequestCategotyWithTypesModel } from "../../../../shared/models/request/request-categoty-with-types-model";
import { UsersService } from "../../../../admin/users/users.service";
import { UserEngineerDto } from "../../../../shared/models/User/user-engineer.dto";
import { PlannedRequestDto } from "../../../../shared/models/request/planned-request.dto";
import { Guid } from "guid-typescript";
import { KeyValueObject } from "../../../../shared/models/core/KeyValueObject";
import { LookupService } from "../../../../shared/services/lookup.service";
import { DialogService } from "@progress/kendo-angular-dialog";
import { CreateCustomerObjectComponent } from "../../../../shared/components/customer-object/create-customer-object/create-customer-object.component";
import { CustomerObjectWithContactsDto } from "../../../../shared/models/customerObject/customer-object-with-contacts.dto";
import { ActivitiesService } from "../../../../shared/services/activities.service";
import { PlanningService } from "../../../../shared/services/planning.service";
import { ActionDataResult } from "../../../../shared/models/core/ActionDataResult";
import { PlanningResultDto } from "../../../../shared/models/planning/planning-result-dto";
import { PlanningMapComponent } from "../planning-map/planning-map.component";
import { PlanningMapMenuComponent } from "../planning-map-menu/planning-map-menu.component";
import { AppService } from "../../../../app.service";
import { MapPointStatesEnum } from "../planning-map/map-point-states.enum";
import { NotificationService } from "../../../../core/services/notification.service";
import { NotificationType } from "../../../../core/services/notification-type";
import { PlanningAutoMapMenuComponent } from "../planning-auto-map-menu/planning-auto-map-menu.component";

@Component({
    selector: 'planning-auto-map',
    templateUrl: './planning-auto-map.component.html',
    styleUrls: [
        './planning-auto-map.component.scss',
        '../../../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss',
        '../../../../../vendor/libs/angular2-ladda/angular2-ladda.scss',
        '../../../../../vendor/libs/ngx-contextmenu/ngx-contextmenu.scss',
    ],
    encapsulation: ViewEncapsulation.None
})
export class PlanningAutoMapComponent implements OnInit {

    @ViewChild('planningMapComponenter') planningMapComponent: PlanningMapComponent;
    @ViewChild('planningMapMenuComponent') planningMapMenuComponent: PlanningAutoMapMenuComponent;

    @Output() cancelPlanningEvent: EventEmitter<any> = new EventEmitter<any>();
    @Output() continueEvent: EventEmitter<any> = new EventEmitter<any>();

    userEngineers: UserEngineerDto[] = [];
    requestUserEngineers: UserEngineerDto[] = [];
    requests: PlannedRequestDto[] = [];

    selectedPlannedDay: Date;
    selectedRequestCategoryIds: number[] = [];
    selectedServiceCenterId: number;
    selectedUserIds: number[] = [];
    lastPlanningResult: PlanningResultDto;

    menuDataLoaded: boolean = false;
    loading: boolean = false;
    planningLoading: boolean = false;
    planningMode: boolean = false;
    confirmPlanningLoading: boolean = false;
    confirmPlanningDisabled: boolean = false;
    categories: KeyValueObject[] = [];

    constructor(
        private activitiesService: ActivitiesService,
        private planningService: PlanningService,
        private dialogService: DialogService,
        private ngZone: NgZone,
        private notificationService: NotificationService,
        private requestsService: RequestsService
    ) { }

    ngOnInit(): void {
        this.planningMapComponent.planningMapComponentName = 'planningAutoMapAngularComponent';
        this.refreshRequests();
        this.startPlanning();
    }

    loadRequests(plannedDate: Date) { }

    refreshRequestUserEngineers() {
        const requestEngineerIds = this.requests.filter(x => x.requestPerformerUserId != null).map(x => x.requestPerformerUserId);
        this.requestUserEngineers = this.userEngineers.filter(x => requestEngineerIds.some(id => x.userId == id));
    }

    changeEngineers(userIds: number[] = []) {
        this.selectedUserIds = userIds;
        this.refreshRequests();
    }

    changeRequestCategories(requestCategoryIds: number[] = []) {
        this.selectedRequestCategoryIds = requestCategoryIds;
        this.refreshRequests();
    }

    changeServiceCenter(serviceCenterId: number) {
        this.selectedServiceCenterId = serviceCenterId;
        this.refreshRequests();
    }

    filterRequestsFromPerformerUser(userId: number) {
        this.planningMapMenuComponent.forceSetUserEngineer(userId);
        this.selectedUserIds = [userId];
        this.refreshRequests();
    }

    refreshRequests() {
        if (this.selectedRequestCategoryIds.length == 0 &&
            this.selectedServiceCenterId == null &&
            this.selectedUserIds.length == 0) {
            this.requests.forEach(x => x.mapPointState = MapPointStatesEnum.default);
        }
        else {
            let filteredRequests = this.requests;

            if (this.selectedRequestCategoryIds.length != 0) {
                filteredRequests = filteredRequests.filter(x => this.selectedRequestCategoryIds.some(c => c == x.requestCategoryId));
            }
            if (this.selectedServiceCenterId != null) {
                filteredRequests = filteredRequests.filter(x => x.serviceCenterId == this.selectedServiceCenterId);
            }

            if (this.selectedUserIds.length > 0) {
                if (this.selectedUserIds.some(x => x == 0)) {
                    filteredRequests = filteredRequests.filter(x =>
                        x.requestPerformerUserId == null ||
                        this.selectedUserIds.some(u => u == x.requestPerformerUserId));
                }
                else {
                    filteredRequests = filteredRequests.filter(x => this.selectedUserIds.some(u => u == x.requestPerformerUserId));
                }
            }

            this.requests.forEach(r => {
                const filtered = filteredRequests.some(f => f.uid == r.uid);
                r.mapPointState = filtered ? MapPointStatesEnum.enabled : MapPointStatesEnum.disabled;
            });
        }

        this.planningMapComponent.refreshRequests(this.requests);
    }

    startPlanning() {
        let cancelStartPlanning$ = new Subject<void>();
        this.planningLoading = true;

        let categoryIds = this.categories.map(x => x.id);

        this.planningService.startPlanning(this.selectedPlannedDay, [], this.selectedServiceCenterId, categoryIds, false, cancelStartPlanning$).subscribe((resp: ActionDataResult<PlanningResultDto>) => {
            this.planningLoading = false;
            this.planningMode = true;
            this.lastPlanningResult = resp.data;

            if (resp.isSuccessful && resp.data != null) {
                resp.data.routes.forEach(route => {
                    route.requests.forEach((planningRequest, index) => {
                        let request = this.requests.find(x => x.activityId == planningRequest.activityId);
                        if (request != null) {
                            request.planOrderNumber = index + 1;
                            request.mapPointState = MapPointStatesEnum.enabled;

                            let engineer = this.userEngineers.find(x => x.integraCode == route.performerIntegraCode);
                            if (engineer != null) {
                                request.requestPerformerUserId = engineer.userId;
                                request.requestPerformerUserName = engineer.displayName;
                                request.requestPerformerUserIntegraCode = engineer.integraCode;
                                request.requestPerformerUserColor = engineer.color;
                            }
                        }
                    });
                });

                let uniqueEnigneersCodes = Array.from(new Set(this.requests.map(x => x.requestPerformerUserIntegraCode).filter(x => x != null)));
                this.requestUserEngineers = this.userEngineers.filter(x => uniqueEnigneersCodes.some(u => u == x.integraCode));

                this.planningMapComponent.refreshRequests(this.requests);
            }
            else {
                this.notificationService.error({
                    title: 'Ошибка',
                    message: 'Произошел сбой в сервисе маршрутизации. Построение маршрута не может быть выполнено в данный момент.',
                    notificationType: NotificationType.SweetAlert
                });
                this.confirmPlanningDisabled = true;
            }
        }, () => {
            this.notificationService.error({
                title: 'Ошибка',
                message: 'Произошел сбой в сервисе маршрутизации. Построение маршрута не может быть выполнено в данный момент.',
                notificationType: NotificationType.SweetAlert
            });
            this.confirmPlanningDisabled = true;
            cancelStartPlanning$.next();
        });
    }

    cancelPlanningMode() {
        this.cancelPlanningEvent.emit();
    }

    confirmPlanning() {
        this.confirmPlanningLoading = true;
        this.planningService.confirmPlanning(this.lastPlanningResult, true).subscribe(() => {
            this.continueEvent.emit();
        });
    }

    setVisitDate(requestId: number) {
        /*
        let request = this.requests.find(x => x.requestId == requestId);
        
        this.ngZone.run(() => {
            const dialogRef = this.dialogService.open({
                content: PlanningMapVisitComponent,
                width: '50%',
            });

            const dialog = <PlanningMapVisitComponent>dialogRef.content.instance;

            dialog.requestIntegraCode = request.integraCode;
            dialog.requestId = requestId;
            dialog.selectedPerformerId = this.requests.find(x => x.requestId == requestId).requestPerformerUserId;
            dialog.userEngineers = this.userEngineers;
            dialog.visitDate = new Date(request.plannedDate);

            dialog.onCancelEvent.subscribe(() => {
                dialogRef.close();
            });
            dialog.onContinueEvent.subscribe((visitContext: IPlanningMapVisitContext) => {
                this.activitiesService.getById(request.activityId).subscribe(activity => {
                    activity.entity.planStartDate = visitContext.visitDate;
                    activity.entity.performerUserId = visitContext.performerUserId;
                    this.activitiesService.update(activity.entity, "Заявка запланирована").subscribe(() => {
                        dialogRef.close();
                    });
                });
            });
        });	
        */
    }
}